import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    max-width: 1400px;
    margin: auto;
    text-align: inherit;
`